import React, { FormEvent, ReactElement, useEffect } from "react";
import "./MyAccount.scss";
import "./AiInterfaceArea.scss";
// import { handleAccountUpdate } from "../controllers/handleAccountUpdate";
import { handleDeleteAccount } from "../controllers/handleDeleteAccount";
import { useDispatch, useSelector } from "react-redux";
import {
  selectAccountDeleteComponent,
  selectAccountDeleteResponse,
  selectAccountDidMount,
  selectAccountUpdateComponent,
  selectAccountUpdateResponse,
  selectGlobalAccount,
} from "../modules/redux/stateSelectors";
import { set } from "../modules/redux/store";
import { AiInterfaceArea } from "./AiInterfaceArea";

export function MyAccount() {
  const didMount = useSelector(selectAccountDidMount);
  const updateResponse: string = useSelector(selectAccountUpdateResponse);
  const deleteResponse: string = useSelector(selectAccountDeleteResponse);
  let updateComponent: stringOrJSX = useSelector(selectAccountUpdateComponent);
  let deleteComponent: stringOrJSX = useSelector(selectAccountDeleteComponent);
  const account = useSelector(selectGlobalAccount);

  const dispatch = useDispatch();

  useEffect(componentDidMount, []);
  useEffect(componentDidUpdate, [didMount, account]);

  if (updateComponent === "updateSuccess")
    updateComponent = <span className="success">{updateResponse}</span>;
  if (updateComponent === "updateFailed")
    updateComponent = <span className="failed">{updateResponse}</span>;

  if (deleteComponent === "deleteSuccess")
    deleteComponent = <span className="success">{deleteResponse}</span>;
  if (deleteComponent === "deleteFailed")
    deleteComponent = <span className="failed">{deleteResponse}</span>;

  if (!account)
    return (
      <main id="notSignedIn" className="container-lg">
        <h1>
          You're not signed in please sign in at the top to view your account.
        </h1>
      </main>
    );
  return (
    <main id="accountMain" className="container-lg">
      <AiInterfaceArea />
      <section id="accountInfo" className="m-2">
        <div className="row">
          <div className="col">
            <h1>Account Information</h1>
          </div>
        </div>
        {/* TODO: Make into BootStrap Cards */}
        <div className="row">
          <div className="col">
            <span className="spanLabel">Email: </span>
            <span className="infoItem">{account.email}</span>
          </div>
          <div className="col">
            <span className="spanLabel">First Name: </span>
            <span className="infoItem">{account.firstName}</span>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <span className="spanLabel">Password: </span>
            <span className="infoItem">{account.password}</span>
          </div>
          <div className="col">
            <span className="spanLabel">Last Name: </span>
            <span className="infoItem">{account.lastName}</span>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <span className="spanLabel">User Name: </span>
            <span className="infoItem">{account.userName}</span>
          </div>
          <div className="col">
            <span className="spanLabel">Phone Number: </span>
            <span className="infoItem">{account.phone}</span>
          </div>
        </div>
      </section>
      {/* <section id="buttonArea">
        <div className="row">
          <div className="col">
            <input
              name="update"
              value="Update Account"
              type="button"
              onClick={handleClickUpdate}
            />
          </div>
          <div className="col">
            <input
              name="delete"
              value="Delete Account"
              type="button"
              onClick={handleClickDelete}
            />
          </div>
        </div>
      </section> */}
      {/* <section className="accountFormSection col-12">
        <h4>Update Information</h4>
        <span>
          Enter your email and the other fields to update your account.
        </span>
        <form onSubmit={handleSubmitUpdate}>
          <div>
            <label>
              Email <span style={{ color: "red" }}>*</span>{" "}
            </label>
            <input type="email" defaultValue={account.email} required />
          </div>
          <div>
            <label>Password </label>
            <input type="password" defaultValue={account.password} />
          </div>
          <div>
            <label>User Name </label>
            <input type="text" />
          </div>
          <div>
            <label>First Name </label>
            <input type="text" placeholder="John" />
          </div>
          <div>
            <label>Last Name </label>
            <input type="text" placeholder="Smith" />
          </div>
          <div>
            <label>Phone Number </label>
            <input
              type="tel"
              pattern="[0-9]{3}[0-9]{3}[0-9]{4}"
              placeholder="##########"
            />
          </div>
          <input id="formSubmitUpdate" type="submit" />
        </form>
        {updateComponent}
      </section> */}
      <section className="accountFormSection m-2 ">
        <div className="row">
          <div className="col">
            <h4>Delete Account</h4>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <span>Enter your email and password to delete your account.</span>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <form onSubmit={handleSubmitDelete}>
              <div className="row">
                <div className="col-4">
                  <label>
                    Email <span style={{ color: "red" }}>*</span>
                  </label>
                </div>
                <div className="col-4">
                  <input type="email" defaultValue={account.email} required />
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <label>
                    Password <span style={{ color: "red" }}>*</span>
                  </label>
                </div>
                <div className="col-4">
                  <input
                    type="password"
                    defaultValue={account.password}
                    required
                  />
                </div>
              </div>
              <div className="row">
                <div className="col text-center">
                  <input type="submit" />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="row">
          <div className="col">{deleteComponent}</div>
        </div>
      </section>
    </main>
  );

  function componentDidMount() {
    console.log("The Account component has mounted.");
    let action = set.accountDidMount(true);
    dispatch(action);
  }

  function componentDidUpdate() {
    if (didMount && account) {
      console.log("The Account component has updated.");
    }
  }

  // function handleClickUpdate() {}
  // function handleClickDelete() {}

  // async function handleSubmitRead(event: FormEvent<HTMLFormElement>) {
  //   const response: string | Account = await handleReadAccount(event);

  //   const isAccount = typeof response === "object";
  //   if (isAccount) {
  //     let action = set.accountReadComponent("readSuccess");
  //     dispatch(action);
  //     action = set.accountReadResponse(response);
  //     dispatch(action);
  //   }
  //   const isMessage = typeof response === "string";
  //   if (isMessage) {
  //     let action = set.accountReadComponent("readFailed");
  //     dispatch(action);
  //     action = set.accountReadResponse(response);
  //     dispatch(action);
  //   }
  // }

  // async function handleSubmitUpdate(event: FormEvent<HTMLFormElement>) {
  //   const response = await handleAccountUpdate(event);
  //   const isUpdated = response.includes("updated");
  //   if (isUpdated) {
  //     let action = set.accountUpdateComponent("updateSuccess");
  //     dispatch(action);
  //     action = set.accountUpdateResponse(response);
  //     dispatch(action);
  //   } else {
  //     let action = set.accountUpdateComponent("updateFailed");
  //     dispatch(action);
  //     action = set.accountUpdateResponse(response);
  //     dispatch(action);
  //   }
  // }

  async function handleSubmitDelete(event: FormEvent<HTMLFormElement>) {
    const response: string = await handleDeleteAccount(event);
    const isDeleted = response === "Your account has been deleted.";
    if (isDeleted) {
      let action = set.accountDeleteComponent("deleteSuccess");
      dispatch(action);
      action = set.accountDeleteResponse(response);
      dispatch(action);
    } else {
      let action = set.accountDeleteComponent("deleteFailed");
      dispatch(action);
      action = set.accountDeleteResponse(response);
      dispatch(action);
    }
  }
}

type stringOrJSX = string | ReactElement;
